import React from 'react';
import { Link } from 'react-router-dom';

import { PATH_MAIN_ROUTE } from '../../router/routes';
import Icon from '../Icon';

export const DrawerHeader: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div id="navbar-header">
    <Link to={PATH_MAIN_ROUTE} id="logo">
      <span className="logo-img">
        <Icon kind="eleveo-square-logo" color="#ffffff" size={26} />
      </span>
      <span className="logo-text">{children}</span>
    </Link>
  </div>
);
